export async function parallel<T extends readonly unknown[]>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]>}> {
	const settlements = await Promise.allSettled(values)
	const errored = settlements.filter(s => s.status === 'rejected')
	if (errored.length) {
		throw new AggregateError(errored.flatMap(s => s.reason instanceof AggregateError ? s.reason.errors : [s.reason]))
	}
	// @ts-ignore
	return settlements.map(s => s.value)
}

export async function tolerantlyParallel<T extends readonly unknown[]>(values: T): Promise<{ -readonly [P in keyof T]: Awaited<T[P]> | undefined}> {
	const settlements = await Promise.allSettled(values)
	const errored = settlements.filter(s => s.status === 'rejected')
	if (errored.length) {
		for (const s of errored) {
			console.warn(`${s.reason.constructor.name}: ${s.reason}`)
			if (s.reason instanceof AggregateError) {
				for (const error of s.reason.errors) {
					console.warn(`\t${error.constructor.name}: ${error}`)
				}
			}
		}
	}
	// @ts-ignore
	return settlements.map(s => s.value)
}
